import * as types from "../actions/ActionTypes";
import {documentIntial} from "../store/InitialStore";

export default function DocumentReducer(state = documentIntial, action) {
  const { type, payload,ID} = action;
  switch (type) {
   case types.ADD_DOCUMENT:
       return [...state,{uniqueId:Date.now(),licenseRequiredDocId:0,documentName:"",documentDescription:"",isMandatory:false,validationType: "string",
       validations: [
         {
             type: "required",
             params: ["Required"]
         }
       ],}]
    case types.DELETE_DOCUMENT:
        return  state.filter((s)=>s.uniqueId!==ID)
    case types.DOCUMENT_VALUE:
        return [...payload]
    case types.DOCUMENT_DETAILS:
      return state=payload
      case types.NEW_DOCUMENT:
        return state=documentIntial
    default:
    return state;
  }
}
